import { sectionRenderer } from '@theme/section-renderer';
import { CartItemsComponent } from '@theme/component-cart-items';

// BOGOS changes the Shopify cart asynchronously. Horizon needs a section refresh
// after those changes; the app's legacy cart events do not refresh this theme.
let lastCart;
let timer;
let refreshing = false;
let queued = false;

async function refreshCart() {
  if (refreshing) { queued = true; return; }
  if (!document.querySelector('cart-items-component')) return;
  refreshing = true;
  try {
    await Promise.all(CartItemsComponent.pendingQuantityUpdates);
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
    if (!response.ok) return;
    const cart = await response.json();
    const signature = JSON.stringify([cart.total_price, cart.items.map(item =>
      [item.key, item.quantity, item.final_line_price, item.line_level_discount_allocations])]);
    if (signature === lastCart) return;
    const sections = new Map([...document.querySelectorAll('cart-items-component')]
      .filter(element => element.dataset.sectionId)
      .map(element => [element.dataset.sectionId, !!element.closest('cart-drawer-component')]));
    for (const [sectionId, drawer] of sections) {
      await sectionRenderer.renderSection(sectionId, {
        cache: false, mode: drawer ? 'hydration' : 'full', injectStylesheet: true
      });
    }
    lastCart = signature;
  } catch (error) {
    if (error.name !== 'AbortError') console.warn('RANGEHEART cart display could not refresh', error);
  } finally {
    refreshing = false;
    if (queued) { queued = false; scheduleRefresh(); }
  }
}

function scheduleRefresh() {
  clearTimeout(timer);
  timer = setTimeout(refreshCart, 250);
}

['bogos:discount-added', 'bogos:cart-updated', 'fg-cart:end-process', 'fg-cart:auto-updated']
  .forEach(name => document.addEventListener(name, scheduleRefresh));
